import type { HelpFile } from '../../types/help'
import { SqlAssistPanelTestIds } from '../../../testids/SqlAssistPanelTestIds'

export const sqlAssistPanelHelp: HelpFile = {
  docPage: '/docs/reporting/sql-assist',
  texts: {
    [SqlAssistPanelTestIds.btnToggleAssist]:
      'Show or hide the AI-assisted SQL panel beside the editor.',
    [SqlAssistPanelTestIds.inputAssistRequest]:
      'Describe in natural language what the SQL should do — the assistant turns the prompt into a query against the IAM schema.',
    [SqlAssistPanelTestIds.selectModel]:
      'Pick which language model generates the SQL suggestion. Different models may produce different style or accuracy.',
    [SqlAssistPanelTestIds.btnSuggestSql]:
      'Send the prompt to the selected model and produce a candidate SQL statement.',
    [SqlAssistPanelTestIds.suggestedSqlPreview]:
      'Read-only preview of the SQL statement returned by the assistant. Review carefully before applying it to the editor.',
    [SqlAssistPanelTestIds.btnApplySuggestion]:
      'Replace the contents of the SQL editor with the previewed suggestion.',
  },
}
